import * as React from 'react';
import { observer } from 'mobx-react';
import { Card } from '@/elements/shared/Card/Card';
import Tooltip from '@/ui-kit/components/Tooltip/Tooltip';

import { TextAttributeState } from './TextAttributeState';
import { AttributeCfgUIElement } from '@/elements/attributes/AttributeLayout';
import { useAttributeTranslation } from '@/localization/useAttributeTranslation';
import classNames from 'classnames';

interface Props {
  state: TextAttributeState;
}

export const TextAttributeCfgUIElement = observer(function TextAttributeCfgUIElement({ state }: Props) {
  const { uiControl } = state.viewElement;
  const itemOptions = uiControl.itemOptions;
  const cardOrientation = uiControl.cardType === 'grid' ? 'vertical' : 'horizontal';
  const tAttr = useAttributeTranslation(state.componentKey, state.attributeKey);
  if (!state.visible) {
    return null;
  }

  return (
    <AttributeCfgUIElement state={state}>
      <ul
        className={classNames('cp-attribute__options', uiControl.cardType === 'grid' && 'cp-attribute__options--card')}
      >
        {state.availableValues.map((value) => {
          const isSelected = state.value === value;
          const text = state.textData.values.find((it) => it.value === value);
          const hasTooltip = itemOptions?.showLongDescription && !!text?.description;
          const displayLabel = tAttr.value(value, text?.label || String(value));

          return (
            <li key={value} className={'cp-attribute__option'}>
              <Tooltip disabled={!hasTooltip} title={displayLabel} description={text?.description}>
                {(onOpen) => (
                  <Card
                    orientation={cardOrientation}
                    value={value}
                    onSelect={state.setValue}
                    selected={isSelected}
                    label={itemOptions?.showTitle ? displayLabel : ''}
                    imageSrc={itemOptions?.showImage ? text?.image?.url : undefined}
                    imageFit={itemOptions?.imageFit}
                    imageType="icon"
                    description={itemOptions?.showDescription ? text?.description : ''}
                    hasTooltip={hasTooltip}
                    onTooltipClick={onOpen}
                  />
                )}
              </Tooltip>
            </li>
          );
        })}
      </ul>
    </AttributeCfgUIElement>
  );
});
